class Heartbeat {
    constructor(timeout, onTimeout, handleTick, setAskisngStillThere) {
        this.timeout = timeout;
        this.onTimeout = onTimeout;
        this.timer = null;
        this.tracking = handleTick;
        this.interval = null;
        this.countdown = timeout / 1000;
        this.setAskisngStillThere = setAskisngStillThere;
    }

    start(){
        this.reset();
    }

    reset(){
        this.countdown = this.timeout / 1000;
        this.setAskisngStillThere(false); // verify if we can optimize this

        if(this.timer) clearTimeout(this.timer);
        if(this.interval) clearInterval(this.interval);

        this.timer = setTimeout(() => {
            this.onTimeout();
            clearInterval(this.interval);
        }, this.timeout);

        this.countdown--;
        this.interval = setInterval(() => {
            if (this.countdown >= 0) {
                this.tracking(this.countdown);
            }

            if (this.countdown <= 10) {
                this.setAskisngStillThere(true);
            }

            this.countdown--;
        }, 1000);
    }

    stop(){
        if(this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    setCountdown(newValue) {
        this.timeout = newValue;
    }
}

export {Heartbeat};